import React, { useEffect } from "react";
import style from "../Form/formfive.module.scss";
import LogoutText from "../../../components/LogoutText/LogoutText";
import {
  rightarrowwhite,
} from "../../../images";
import FullWidthTextField from "../../../components/TextField/FullWidthTextField";

const FAStep13 = ({
  nextStep,
  previousStep,
  currentStep,
  totalSteps,
  progressStatus,
}) => {
  useEffect(() => {
    progressStatus((currentStep / totalSteps) * 100);
  }, [currentStep, progressStatus, totalSteps]);

  return (
    <>
      <div className={style.text_container}>
        <h1 className={style.title}>Take Us Through Your Work Space</h1>
        <p className={style.description}></p>
      </div>
      <div className={`${style.steps} ${style.fastep13}`}>
        <div className={style.field_wrapper}>
          <FullWidthTextField label="Link to the video" />
          <p className={style.error}></p>
          <div className={style.virtual_notice}>
           Add store video or virtual walkthrough link of office
          </div>
        </div>
      </div>

      <div className={style.next_logout}>
        <div className={style.cta_wrapper}>
          <div
            className={style.next_button}
            onClick={() => {
              nextStep(10);
              window.scrollTo(0, 0);
            }}
          >
            <div className={style.text}>Next</div>
            <img
              src={rightarrowwhite}
              alt="icon"
              className={style.icon}
              loading="lazy"
            />
          </div>
          <div
            className={style.back_button}
            onClick={() => {
              previousStep(8);
              window.scrollTo(0, 0);
            }}
          >
            Back
          </div>
        </div>
        <LogoutText />
      </div>
    </>
  );
};

export default FAStep13;
